<div class="container-message">
  <!-- <svg-icon
    src="../../../assets/icons/exclamation-message.svg"
    [svgStyle]="{
      'width.rem': 1.5,
      'height.rem': 1.5,
      position: 'relative',
      'top.rem': 0.15
    }"
  ></svg-icon> -->
  <mat-icon>info_outline</mat-icon>
  <ul>
    <li>
      {{ message }}
    </li>
  </ul>
</div>
